import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
const defaultOptions = {} as const;

export type CreateScimApiKeyMutationVariables = GraphQLTypes.Exact<{
  input?: GraphQLTypes.InputMaybe<GraphQLTypes.CreateScimApiKeyInput>;
}>;

export type CreateScimApiKeyMutationResult = { __typename?: 'Mutation' } & {
  createScimApiKey?: GraphQLTypes.Maybe<
    { __typename?: 'CreateScimApiKeyPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'path'>>>;
    }
  >;
};

export const CreateScimApiKeyDocument = /*#__PURE__*/ gql`
  mutation createScimApiKey($input: CreateScimApiKeyInput) {
    createScimApiKey(input: $input) {
      errors {
        path
      }
    }
  }
`;

/**
 * __useCreateScimApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateScimApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScimApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScimApiKeyMutation, { data, loading, error }] = useCreateScimApiKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateScimApiKeyMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateScimApiKeyMutationResult, CreateScimApiKeyMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<CreateScimApiKeyMutationResult, CreateScimApiKeyMutationVariables>(CreateScimApiKeyDocument, options);
}
export type CreateScimApiKeyMutationHookResult = ReturnType<typeof useCreateScimApiKeyMutation>;
